import { Modal } from '@components/ui';
import { buildFullName } from '@hilbi/web-common/utils/common';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { TWaiting } from 'types/patients';

type TProps = {
  visible?: boolean;
  item?: TWaiting;
  onClose?: () => void;
  onRemove?: (w: TWaiting, reason?: string) => void;
};

const PatientRejectModal: React.FC<TProps> = ({ onClose, onRemove, item, visible }) => {
  return (
    <Modal
      title={<FormattedMessage id="patient_reject.btn" />}
      visible={visible}
      onClose={onClose}
      destroyOnClose
      footer={
        <Modal.Actions
          actions={[
            {
              key: 'cancel',
              variant: 'ghost',
              label: <FormattedMessage id="office_hours.cancel_btn" />,
              onClick: onClose,
            },
            {
              key: 'submit',
              variant: 'danger',
              label: <FormattedMessage id="patient_reject.btn" />,
              onClick: () => {
                if (item) {
                  onRemove?.(item);
                }
              },
            },
          ]}
        />
      }
    >
      <Modal.Title>
        <FormattedMessage id="patient_reject.title" />
      </Modal.Title>
      <Modal.Description>
        {buildFullName(
          item?.client.profile.titleBeforeName,
          item?.client.profile.firstName,
          item?.client.profile.lastName,
          item?.client.profile.titleAfterName,
        )}
      </Modal.Description>
    </Modal>
  );
};

export default PatientRejectModal;
